import { BookOpen } from "lucide-react"

import { FeatureCard } from "./feature-card"
import type { DashboardWord } from "@/types"

interface WordsCardProps {
  words: DashboardWord[]
  animationDelay?: number
}

export function WordsCard({ words, animationDelay = 0 }: WordsCardProps) {
  return (
    <FeatureCard
      title="Words"
      icon={BookOpen}
      iconColor="text-teal-600 dark:text-teal-400"
      iconBgColor="bg-teal-100 dark:bg-teal-900/30"
      href="/words"
      animationDelay={animationDelay}
    >
      {words.length === 0 ? (
        <div className="py-4 text-center">
          <p className="text-muted-foreground text-sm">No words yet</p>
          <p className="text-muted-foreground mt-1 text-xs">
            Browse Thai vocabulary
          </p>
        </div>
      ) : (
        <ul className="space-y-3">
          {words.map((word) => (
            <li
              key={word.slug}
              className="bg-muted/30 hover:bg-muted/50 rounded-lg px-3 py-2 transition-colors"
            >
              <div className="flex items-baseline justify-between gap-2">
                <p className="text-foreground text-base font-medium">
                  {word.thaiScript}
                </p>
                <p className="text-muted-foreground text-xs">{word.english}</p>
              </div>
              {word.romanization && (
                <p className="text-muted-foreground mt-0.5 text-xs">
                  {word.romanization}
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </FeatureCard>
  )
}
